import { formatCurrency } from '@sylveraio/react-utils'
import { TickFormat } from '../../types'

export function formatTick(
  value: number | string,
  tickFormat: TickFormat | undefined,
  decimalPlaces = 0,
) {
  switch (tickFormat) {
    case TickFormat.CurrencyUSD: {
      return formatCurrency(value, decimalPlaces)
    }
    case TickFormat.Default:
    default: {
      return value
    }
  }
}
